import ModelService from '@/services/model.service';
import { getField, updateField } from 'vuex-map-fields';
import i18n from '@/locales/i18n';

const SET_MODELS = 'SET_MODELS';
const SET_MODEL = 'SET_MODEL';
const RESET = 'RESET';
const FIRST_IDX = 0;

export default {
	namespaced: true,
	state() {
		return {
			models: [],
			model: null,
		};
	},
	actions: {
		/**
		 * Retrieve model list from the server
		 * @param {*} param0
		 * @param {Object} payload: username of the user
		 */
		async retrieveModels({ commit }, payload) {
			const response = await ModelService.retrieveModelList({
				user: payload.username,
			});
			let db_models = response.data.db_models;

			const fistModel = db_models[FIRST_IDX]?.model_name;
			commit(SET_MODELS, db_models)
			commit(SET_MODEL, fistModel);
		},

		async deleteModel({ commit }, payload) {
			await ModelService.delete(payload);
		
		},

		/**
		 * Set selected model
		 * @param {*} param0
		 * @param {Object} payload: selected model
		 */
		setModel({ commit }, payload) {
			console.log('selected model: ', payload);
			commit(SET_MODEL, payload.model);
		},

		resetTrainerModels({ commit }) {
			commit(RESET);
		},
	},

	mutations: {
		updateField,

		SET_MODEL(state, payload) {
			state.model = payload;
		},

		SET_MODELS(state, payload) {
			state.models = payload;
		},

		RESET(state) {
			state.model = null;
			state.models = [];
		},
	},

	getters: {
		getField,
	},
};
